import { render, staticRenderFns } from "./tumorPage.vue?vue&type=template&id=68421a95&scoped=true"
import script from "./tumorPage.vue?vue&type=script&lang=js"
export * from "./tumorPage.vue?vue&type=script&lang=js"
import style0 from "./tumorPage.vue?vue&type=style&index=0&id=68421a95&prod&scoped=true&lang=css"
import style1 from "./tumorPage.vue?vue&type=style&index=1&id=68421a95&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68421a95",
  null
  
)

export default component.exports